import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewpersonFormComponent } from './component/newperson-form/newperson-form.component';
import { PersonListComponent } from './component/person-list/person-list.component';
import { PersonComponent } from './pages/person/person.component';
import { PersonRoutingModule } from './person-routing.module';

import { PersonService } from './services/person.service';
import { DynamicFormModule } from 'src/app/core/components/dynamic-form/dynamic-form.module';
import { SearchPersonComponent } from './component/search-person/search-person.component';
import { CommonTLFModule } from 'src/app/common/common.module';
import { DetailPersonComponent } from './component/detail-person/detail-person.component';


@NgModule({
  declarations: [
    PersonComponent,
    PersonListComponent,
    NewpersonFormComponent,
    SearchPersonComponent,
    DetailPersonComponent
],
  imports: [
    CommonModule,
    PersonRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    DynamicFormModule,
    CommonTLFModule

  ],
  exports : [
    SearchPersonComponent,
    NewpersonFormComponent
  ],

  providers : [PersonService]
})
export class PersonModule { }
